import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Masquer l'écran de chargement une fois l'app montée
const splash = document.getElementById('app-splash');
if (splash) {
  setTimeout(() => {
    splash.classList.add('app-splash-hidden');
    setTimeout(() => splash.remove(), 450);
  }, 300);
}

// Met à jour le logo de l'écran de chargement (config globale superadmin) en arrière-plan,
// pour que le prochain chargement affiche immédiatement le bon logo depuis le cache localStorage
(function refreshSplashLogo() {
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  fetch(`${API_BASE_URL}/notifications/church-settings/`)
    .then((res) => res.ok ? res.json() : null)
    .then((data) => {
      if (!data) return;
      const url = data.platform_splash_logo || '';
      const cached = localStorage.getItem('platform_splash_logo') || '';
      if (url !== cached) {
        if (url) {
          localStorage.setItem('platform_splash_logo', url);
        } else {
          localStorage.removeItem('platform_splash_logo');
        }
      }

      const bg = data.platform_splash_bg_color || '';
      const cachedBg = localStorage.getItem('platform_splash_bg_color') || '';
      if (bg !== cachedBg) {
        if (bg) {
          localStorage.setItem('platform_splash_bg_color', bg);
        } else {
          localStorage.removeItem('platform_splash_bg_color');
        }
      }
    })
    .catch(() => {});
})();

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration);

        // Vérifie immédiatement et périodiquement si une nouvelle version est disponible
        registration.update();
        setInterval(() => registration.update(), 60 * 60 * 1000);

        // Sur mobile (PWA), l'app reste souvent en arrière-plan sans recharger :
        // revérifier à chaque retour au premier plan pour détecter les mises à jour.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update();
          }
        });

        const notifyUpdate = (worker) => {
          // Mémorisé sur window : si UpdateBanner se monte APRÈS ce dispatch
          // (course possible entre le chargement du SW et le montage de React),
          // il peut quand même récupérer le worker en attente au montage.
          window.__pendingSwUpdate = worker;
          window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { worker } }));

          // En plus du bandeau in-app, affiche une vraie notification système
          // (visible même app fermée/en arrière-plan) pour inciter à mettre à jour.
          // 'Notification' n'existe pas du tout dans certains contextes (webview iOS
          // notamment) — un accès direct à .permission y lèverait un ReferenceError
          // et casserait toute la promesse en cours, y compris l'attache du listener
          // 'updatefound' plus bas si l'ordre d'exécution différait.
          if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
            registration.showNotification('Mise à jour disponible', {
              body: 'Une nouvelle version de l\'application est prête. Ouvrez l\'app pour l\'installer.',
              icon: '/logo192.png',
              badge: '/logo192.png',
              tag: 'app-update',
              data: { url: '/' },
            }).catch(() => {});
          }
        };

        // Une version est déjà en attente (téléchargée avant ce chargement)
        if (registration.waiting) {
          notifyUpdate(registration.waiting);
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && registration.active) {
              notifyUpdate(newWorker);
            }
          });
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });

  // Quand le nouveau service worker prend le contrôle (après clic sur "Actualiser"),
  // recharger la page pour appliquer la mise à jour.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
